const configuredMediaUrl = process.env.REACT_APP_MEDIA_URL || 'https://media.cvad.tv/portfolio-assets';

export const mediaUrl = configuredMediaUrl.replace(/\/$/, '');

export const mediaAsset = (path) => `${mediaUrl}/${path.replace(/^\//, '')}`;
